const ACADEMY_CDN_BASE = process.env.REACT_APP_ACADEMY_CDN_BASE;
//const ACADEMY_CDN_BASE = 'http://localhost:3000/academy-stub';
//const ACADEMY_CDN_BASE = 'http://localhost:3001';

export const getAcademyBaseUrl = () => {
  if (!ACADEMY_CDN_BASE) {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  const preview = params.get('preview');
  const normalizedBase = ACADEMY_CDN_BASE.replace(/\/$/, '');

  if (preview) {
    return `${normalizedBase}/previews/${preview}`;
  }

  return `${normalizedBase}/live`;
};

export const loadAcademyManifest = async (baseUrl) => {
  if (!baseUrl) {
    throw new Error('Academy CDN base URL is not configured.');
  }

  const response = await fetch(`${baseUrl}/manifest.json`);

  if (!response.ok) {
    throw new Error(`Failed to load Academy manifest (${response.status}).`);
  }

  return response.json();
};

export const loadAcademyLessonMarkdown = async (baseUrl, slug) => {
  if (!baseUrl) {
    throw new Error('Academy CDN base URL is not configured.');
  }

  const response = await fetch(`${baseUrl}/lessons/${slug}.md`);

  if (response.status === 404) {
    return { notFound: true };
  }

  if (!response.ok) {
    throw new Error(`Failed to load lesson (${response.status}).`);
  }

  const markdown = await response.text();
  return { markdown };
};

export const replaceDeeplinkShortcodes = (markdown) => {
  if (!markdown) {
    return markdown;
  }

  return markdown.replace(/\[\[deeplink\s+([^\]]+)\]\]/gi, (match, attrs) => {
    const attrMap = {};
    const attrRegex = /(\w+)="([^"]*)"/g;
    let attrMatch = attrRegex.exec(attrs);

    while (attrMatch) {
      attrMap[attrMatch[1]] = attrMatch[2];
      attrMatch = attrRegex.exec(attrs);
    }

    if (!attrMap.label || !attrMap.to) {
      return match;
    }

    return `[${attrMap.label}](${attrMap.to})`;
  });
};

export const resolveAcademyAssetUrl = ({ baseUrl, slug, src }) => {
  if (!src) {
    return src;
  }

  if (src.startsWith('http://') || src.startsWith('https://')) {
    return src;
  }

  if (!baseUrl) {
    return src;
  }

  const normalizedBase = baseUrl.replace(/\/$/, '');

  if (src.startsWith('/')) {
    return `${normalizedBase}${src}`;
  }

  const lessonsBase = `${normalizedBase}/lessons/`;
  return new URL(src, lessonsBase).toString();
};
